import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about-us',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/palm-cove',
    name: 'Palm Cove',
    component: () => import('../views/PalmCove.vue'),
  },
  {
    path: '/the-team',
    name: 'The Team',
    component: () => import('../views/TheTeam.vue'),
  },
  {
    path: '/off-market/introduction',
    name: 'Off Market',
    meta: {
      hide: true,
    },
    component: () => import('../views/OffMarketIntroduction.vue'),
  },
  {
    path: '/off-market/register',
    name: 'Off Market Registration',
    meta: {
      hide: true,
    },
    component: () => import('../views/OffMarketRegistration.vue'),
  },
  {
    path: '/off-market/properties-for-sale',
    name: 'Off Market Listings',
    meta: {
      hide: true,
    },
    component: () => import('../views/OffMarketListings.vue'),
  },
  {
    path: '/properties-for-sale',
    name: 'Properties For Sale',
    component: () => import('../views/PropertiesForSale.vue'),
  },
  {
    path: '/luxury-properties-for-sale',
    name: 'Luxury Properties For Sale',
    component: () => import('../views/LuxuryPropertiesForSale.vue'),
  },
  // {
  //   path: '/testimonials',
  //   name: 'Testimonials',
  //   component: () => import('../views/Testimonials.vue'),
  // },
  {
    path: '/land-for-sale',
    name: 'Land For Sale',
    component: () => import('../views/LandForSale.vue'),
  },
  // {
  //   path: '/commercial',
  //   name: 'Commercial',
  //   component: () => import('../views/Commercial.vue'),
  // },
  {
    path: '/properties-for-rent',
    name: 'Properties For Rent',
    component: () => import('../views/PropertiesForRent.vue'),
  },
  {
    path: '/luxury-properties-for-rent',
    name: 'Luxury Properties For Rent',
    component: () => import('../views/LuxuryPropertiesForRent.vue'),
  },
  {
    path: '/open-homes',
    name: 'Inspection Times',
    component: () => import('../views/InspectionTimes.vue'),
  },
  {
    path: '/sold',
    name: 'Sold',
    component: () => import('../views/Sold.vue'),
  },
  {
    path: '/request-an-appraisal',
    name: 'Sales Appraisal',
    component: () => import('../views/SalesAppraisal.vue'),
  },
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: () => import('../views/ContactUs.vue'),
  },
  {
    path: '/listings/:id',
    name: 'Listing',
    component: () => import('../views/ListingDetails.vue'),
  },
  {
    path: '/profiles/:id',
    name: 'Profile',
    component: () => import('../views/AgentProfile.vue'),
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: () => import('../views/Sitemap.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/*',
    name: 'Not Found',
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
});

export default router;
